module.exports = __webpack_public_path__ + "img/Mary-Pily-Loo-.65c201bd.png";